export const everythingSelectedSearch = "ChjwZb";
export default {everythingSelectedSearch};